<template>
  <div class="wrapper_out">
    <div class="message_wrap">
      <div class="error_msg_wrap">
        <h4 style="color:red">{{ $t('cop.pm.in.title') }}</h4>
        <h5>{{`${$t('cop.pm.in.date-n-time')} ${startDate}${startTime} - ${endDate}${endTime} (${gmt})`}}</h5>
        <p>{{ $t('cop.pm.in.message1') }}</p>
        <p>{{ $t('cop.pm.in.message2') }}</p>
        <p>{{ $t('cop.pm.in.message3') }}</p>
        <p v-html="$t('cop.pm.in.message4')"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';

export default {
  data() {
    return {
      content: null,
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null,
    };
  },
  computed: {
    ...mapGetters({
      maintenance: 'getMaintenance',
      gmt: 'getGMT',
    }),
  },
  mounted() {
    const start = moment(this.maintenance.fromPeriod);
    this.startDate = start.format('YYYY.MM.DD ');
    this.startTime = start.format('HH:mm:ss');
    const end = moment(this.maintenance.toPeriod);
    let endDate = end.format('YYYY.MM.DD ');
    this.endTime = end.format('HH:mm:ss');
    if (this.startDate === endDate) endDate = '';
    this.endDate = endDate;
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/view/admin/maintenance/Maintenance.vue